import StandardHoldingDocuments from "./standard-holding-documents";

export default StandardHoldingDocuments;
